import { gql } from "@/services/httpAdapter";

export const onUpdatePeriodPayrollProviders = gql`
	subscription onUpdatePeriodPayrollProviders($locationId: String = "") {
		onUpdatePeriodPayrollProviders(locationId: $locationId) {
			locationId
			payPeriods {
				_id
				title
				payPeriodProviders {
					providerPayPeriodId
					status
				}
			}
		}
	}
`;
